import React, { useEffect, useState } from "react";
import { CreditCard, ChevronRight } from "lucide-react";
import api, { TRY, trDate } from "@/lib/api";
import { Card } from "@/components/Cards";

export default function CardDueBanner({ goTo }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/cashbook/card-reminders").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <Card className="p-4 border-violet-500/40 bg-violet-500/5" data-testid="card-due-banner">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-lg bg-violet-500/15 text-violet-400 flex items-center justify-center shrink-0"><CreditCard className="h-5 w-5" /></div>
          <div>
            <div className="font-heading font-semibold text-violet-300">Yaklaşan kredi kartı ödemesi</div>
            <div className="text-sm text-muted-foreground mt-0.5 flex flex-wrap gap-1.5">
              {items.map((c) => (
                <span key={c.account_id} data-testid={`card-due-${c.account_id}`} className="rounded-md bg-card/70 border border-border px-2 py-0.5 text-xs">
                  <span className="font-medium text-foreground">{c.name}</span> · son ödeme {trDate(c.due_date)}{" "}
                  <span className={`font-mono ${c.days_left <= 2 ? "text-rose-400" : "text-violet-300"}`}>({c.days_left === 0 ? "bugün" : `${c.days_left} gün`})</span>
                  {c.debt > 0 && <> · borç <span className="font-mono text-rose-400">{TRY(c.debt)}</span></>}
                </span>
              ))}
            </div>
          </div>
        </div>
        <button onClick={() => goTo && goTo("cashbook")} data-testid="card-due-goto" className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline">Kasa Defteri'ne git <ChevronRight className="h-4 w-4" /></button>
      </div>
    </Card>
  );
}
